// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"86":"15e638ad","164":"60c71817","645":"60c71817","875":"ac8cee2f"}[chunkId] + ".chunk.css";
};